import defaultValue from "./currentSearchSlice";

export default defaultValue;
export * from "./currentSearchSlice";
export * from "./currentSearchSlice.types";
